import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, toRefs } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleChecker',
  props: {
  modelValue: {
    type: Boolean,
    default: false,
  },
  value: {
    type: Boolean,
    default: false,
  },
  label: {
    default: '',
  },
},
  emits: ['update:modelValue'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props

const { modelValue } = toRefs(props)
const emit = __emit
const val = ref(false)

function setValue(val) {
  emit("update:modelValue", val)
}

watch(() => props.modelValue, (nval) => {
  val.value = nval
  setValue(nval)
}, { deep: true, immediate: true })


const __returned__ = { props, modelValue, emit, val, setValue, ref, watch, toRefs }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})